module.exports = __webpack_public_path__ + "img/yqh4.3342888f.jpg";